export function isSubcontractorInviteProfileComplete(u) {
  if (!u) return false;
  if (u.subcontractor_invite_onboarding_completed === true) return true;
  if (u.registration_step && u.registration_step !== 'completed') return false;
  const hasBusinessType = u.business_type && u.business_type !== '';
  const hasTradeType = u.trade_type && u.trade_type !== '';
  const hasFullName = u.full_name && u.full_name !== '';
  if (u.subcontractor_invite_onboarding_completed === false) return false;
  return (
    hasBusinessType &&
    hasTradeType &&
    hasFullName
  );
}

export function requiresSubcontractorInviteWizard(user) {
  const canUseSubcontractorDashboard =
    Array.isArray(user?.employers) && user.employers.length > 0;
  if (!canUseSubcontractorDashboard) return false;
  return !isSubcontractorInviteProfileComplete(user);
}
